const CircleArrowDownRightIcon = /*#__PURE__*/ [
  ["path", { d: "M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M15 10V12C15 13.4142 15 14.1213 14.5607 14.5607C14.1213 15 13.4142 15 12 15H10M14 14L9 9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { CircleArrowDownRightIcon as default };
//# sourceMappingURL=CircleArrowDownRightIcon.js.map
